import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { userActions } from "../../redux/_actions";
import { Navigate } from "react-router-dom";
import severUrl from "../../api";
import searchIcon from "../../assets/images/searchbtn.png"
import closeIcon from "../../assets/images/close.png"


class SearchInput extends React.Component {
  // updateInputValue(evt) {
  //   const val = evt.target.value;
  //   // ...
  //   this.setState({
  //     inputValue: val
  //   });
  constructor(props) {
    super(props);
  }

  state = {
    inputKey: '',
  }

  _handleKeyPress(e) {
    if (e.key === "Enter") {
      this.props.triggerHandler(this.state.inputKey)
    }
  }

  handleValue(value)
  {
    this.setState({inputKey: value})
  }

  render() {
    const { searchResult, custom_style } = this.props;
    return (
      <div className="flex-container" style={{display:"flex", flexDirection:"row", marginLeft:"10px", marginRight:"10px", height:"100%", alignItems:"center"}}>
        {/* <button style={{backgroundColor:"white", margin:"0", padding:"0", border:"none"}}><img style={{maxWidth:"28px"}} src={searchIcon} /></button> */}
      
        <div style={{alignContent:"center", order:"1", height:"100%", paddingTop:"5px"}}>
        
        <button  onClick={()=>this.props.triggerHandler(this.state.inputKey)} style={{backgroundColor:"transparent", margin:"0", padding:"0", border:"solid 1px grey",
          borderRadius:"5px",
          borderTopLeftRadius:"5px",
          borderBottomLeftRadius:"5px",
          backgroundColor:"white",
          borderTopRightRadius:"0",
          borderBottomRightRadius:"0",
          borderRight:"none",
          height:"30px",
          backgroundImage:'url(' + require('../../assets/images/search.png') + ')',
          backgroundPosition: 'center',
          backgroundSize:"60%",
          backgroundRepeat:"no-repeat",
          width:"30px"
          
        }}></button>
        
        </div>
      <div style={{order:"2"}}>
      <input
        type="search"
        placeholder="Search"
        className="search-input"
        value={this.state.inputKey}
        style={{
                border: "solid 1px grey",
                borderRadius: "0",
                borderLeft:"none",
                borderRight:"none",
                borderTopRightRadius:"0",
                borderBottomRightRadius:"0",
                width:"fit-content",
                // alignItems: "start",
                height: "30px",
                // backgroundImage: 'url(' + require('../../assets/images/search.png') + ')',
                // backgroundPosition: 'left',
                // backgroundSize: '10%',
                // backgroundRepeat: 'no-repeat',
                // paddingLeft:"30px",
                // position:"absolute"
              }
        }
        onChange={(e)=> this.handleValue(e.target.value)}
        onKeyPress={(e) => this._handleKeyPress(e)}
      /></div>
      
      <div style={{alignContent:"center", order:"3", height:"100%", paddingTop:"5px"}}>
        
      <button  onClick={()=> this.props.showHandler()} style={{backgroundColor:"transparent", margin:"0", padding:"0", border:"solid 1px grey",
        borderRadius:"5px",
        borderTopRightRadius:"5px",
        borderBottomRightRadius:"5px",
        backgroundColor:"white",
        borderTopLeftRadius:"0",
        borderBottomLeftRadius:"0",
        borderLeft:"none",
        height:"30px",
        backgroundImage:'url(' + require('../../assets/images/close.png') + ')',
        backgroundPosition: 'center',
        backgroundSize:"100%",
        width:"30px"
        
      }}></button>
      
      </div>
      
      
      </div>
      // <form onsubmit="event.preventDefault();" role="search" 
      //   style={{  position: "relative",
      //     width: "95%",
      //     background: "transparent",
      //     borderRadius: "var(--rad)",
      //     padding:"0px",
      //   }}
      // >
      //   <input
      //   style={{
      //     height:"36px",
      //     margin:"10px",
      //     outline: 0,
      //     width: "100%",
      //     background: "var(--color-light)",
      //     padding: "0 1.6rem",
      //     borderRadius: "var(--rad)",
      //     borderColor:"transparent",
      //     appearance: "none", 
      //     transition: "all var(--dur) var(--bez)",
      //     transitionProperty: "width, border-radius",
      //     zIndex: 1,
      //     position: "relative"
      //   }}
      //   id="search" type="search" placeholder="Search..." autofocus required />
      // </form>
    );
  }
}

function mapState(state) {
  const { searchResult } = state.searchResult;
  return { searchResult };
}

const actionCreators = {
  search: userActions.search,
};

// const connectedSearchInput = connect(mapState, actionCreators)(SearchInput);
// export withRouter({ connectedSearchInput as SearchInput };)
export default SearchInput;


